// Opening-hours based booking slots.
// Mon-Fri: 12:00-14:30 & 17:30-20:30, Sat: 11:00-15:00, Sun: closed.
const WEEKDAY_WINDOWS = [[12 * 60, 14 * 60 + 30], [17 * 60 + 30, 20 * 60 + 30]];
const SATURDAY_WINDOWS = [[11 * 60, 15 * 60]];

// Scheduled shop closures (inclusive). Fallback defaults — the live list is
// managed from the dev admin and fetched from /api/store/closures.
// Format: { start: "YYYY-MM-DD", end: "YYYY-MM-DD", reason: "summer" }
// hide_popup_from = date (inclusive) on which the front-page popup stops showing.
export const CLOSURES = [
  { start: "2026-08-09", end: "2026-08-23", hide_popup_from: "2026-08-23", reason: "summer" },
];

let _dynamic = null; // null = not loaded yet → use CLOSURES fallback

export async function loadClosures() {
  try {
    const base = process.env.REACT_APP_BACKEND_URL;
    const res = await fetch(`${base}/api/store/closures`);
    const data = await res.json();
    _dynamic = Array.isArray(data.closures) ? data.closures : [];
  } catch (e) { /* keep fallback */ }
  return _dynamic || CLOSURES;
}

function activeClosures() {
  return _dynamic || CLOSURES;
}

function toYMD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function isHolidayDate(date) {
  if (!date) return false;
  const ymd = toYMD(date);
  return activeClosures().some((c) => ymd >= c.start && ymd <= c.end);
}

export function getActiveOrUpcomingClosure() {
  const today = toYMD(new Date());
  // Popup is shown until (but not on) hide_popup_from; fallback to end.
  return activeClosures().find((c) => today < (c.hide_popup_from || c.end)) || null;
}

export function isClosedDay(date) {
  if (!date) return false;
  return date.getDay() === 0 || isHolidayDate(date); // Sunday or holiday
}

export function getSlotsForDate(date) {
  if (!date) return [];
  if (isHolidayDate(date)) return [];
  const day = date.getDay(); // 0=Sun..6=Sat
  if (day === 0) return [];
  const windows = day === 6 ? SATURDAY_WINDOWS : WEEKDAY_WINDOWS;
  const slots = [];
  windows.forEach(([start, end]) => {
    let t = start;
    while (t + 30 <= end) {
      slots.push(`${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`);
      t += 30;
    }
  });
  return slots;
}

// Disable past dates, Sundays and holiday ranges in a react-day-picker calendar.
export function isDateDisabled(d) {
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  return d < today || d.getDay() === 0 || isHolidayDate(d);
}
